import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSearchComponent implements OnInit {
  @Input()
  users;

  @Output()
  addUser = new EventEmitter();

  _selectedUser;

  searchUser = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(
        term =>
          term.length < 2
            ? []
            : this.users
                .map(x => ({
                  ...x,
                  fullName: `${x.firstName} ${x.lastName}`
                }))
                .filter(x =>
                  x.fullName.toLowerCase().indexOf(term.toLowerCase()) > -1
                )
                .slice(0, 10)
      )
    );

  searchFormatter = x => x.fullName;

  constructor() {}

  ngOnInit() {}

  selectUser(e, input) {
    e.preventDefault();
    this._selectedUser = e.item;
    this.addUser.emit(this._selectedUser.id);
    input.value = '';
  }

  // removeUser(userId) {
  //   this.usersChanged.emit(this.selectedUserIds.filter(id => id !== userId));
  // }
}
